import ISelectedContractors from "rules/interface/selected-contractor/selected-contractor.interface";

class SelectedContractorService {
    getContractors() {
        return typeof window !== "undefined" && (JSON.parse(localStorage.getItem("selected_contractors")) as ISelectedContractors[]) || [];
    }
    getContractorsId() {
        if(typeof window !== "undefined") {
            const contractors: ISelectedContractors[] = JSON.parse(localStorage.getItem("selected_contractors")) || [];
            
            return contractors.map(res => res._id) as string[] ?? []
        }
    }
    setNewContractor(contractor: ISelectedContractors) {
        if (typeof window !== "undefined" && contractor) {
            const currentContractors: ISelectedContractors[] = JSON.parse(localStorage.getItem("selected_contractors")) ?? [];
            if (currentContractors.length < 2) {
                currentContractors.push(contractor)

                localStorage.setItem("selected_contractors", JSON.stringify(currentContractors))
            }
        }
    }
    
    setContractors(contractor: ISelectedContractors[]) {
        if (typeof window !== "undefined") {
            if (contractor.length <= 2)
                localStorage.setItem("selected_contractors", JSON.stringify(contractor))
        }
    }
    
    deleteContractor(id: string) {
        if (typeof window !== "undefined") {
            let currentContractors: ISelectedContractors[] = JSON.parse(localStorage.getItem("selected_contractors")) ?? [];

            currentContractors = currentContractors.filter(res => res._id !== id)
            localStorage.setItem("selected_contractors", JSON.stringify(currentContractors))
        }
    }
}
export default new SelectedContractorService();